import React from "react";
import cn from "classnames";
import {Link} from "react-router-dom";
import styles from "./Card.module.sass";
import Actions from "../Actions";
import Player from "../Player";
import config from '../../config'

const Card = ({className, item, imageSize = {h: 303, w: 256}}, users) => {

    return (
        <div className={cn(styles.card, className)}>
            <div className={styles.preview}>
                <div className={styles.id_section}>
                  <div className={cn(styles.id)}>
                    ID:
                    <span>{item.token_id}</span>
                  </div>
                </div>
                <Player item={item} sizes={imageSize}/>
                <div className={styles.options}><Actions item={item} users={users}/></div>
            </div>
            <Link className={styles.link} to={'/item/' + item.seo_url}>
                <div className={styles.body}>
                    <div className={styles.line}>
                        <div className={styles.title}>{item.name}</div>
                        <div className={styles.price}>{item.ether_price}&nbsp;{config.symbolName}</div>
                    </div>
                </div>
            </Link>
        </div>
    );
};

export default Card;
